module.exports = __webpack_public_path__ + "img/line-graph-icon-21022022.a19457c4.svg";